import React from 'react'
import { App } from './views'
import { AppIcon } from './components';
import { routesConfig } from './routesConfig'

const displayName = "Admin Tools"
const name = displayName.toLowerCase().replace(' ', '_')

export const appDefinition = {
	displayName: displayName,
	name: name,
	category: 'admin',
	// Already reachable via the header's admin-tools menu button — a Home-grid
	// tile would just be a duplicate entry point.
	hideFromHomeGrid: true,
	Component: () => <App appName={name}/>,
	AppIcon: AppIcon,
	routes: routesConfig(name, displayName)
}